import React from 'react';
import { Bar } from 'react-chartjs-2';
import randomColor from 'randomcolor';

const GraphicLeadsByResponsibleAndStatus = ({
  leadsCountByResponsibleAndStatus
}) => {
  const getGraphicResponsibleLabels = () => {
    if (!leadsCountByResponsibleAndStatus) return [];
    return leadsCountByResponsibleAndStatus?.map(
      (item) => `${item.responsibleName}`
    );
  };

  const dataSets = () => {
    if (!leadsCountByResponsibleAndStatus) return [];
    const items = [];
    leadsCountByResponsibleAndStatus.forEach((responsible) => {
      responsible.stages.forEach((stage) => {
        const existsStage = items.some(
          (item) => item.label === stage.stageName
        );
        if (!existsStage) {
          items.push({
            label: stage.stageName,
            backgroundColor: randomColor({
              luminosity: 'random',
              hue: 'random'
            }),
            stack: 1,
            data: [stage.quantity]
          });
        } else {
          const value = items.find((item) => item.label === stage.stageName);
          value.data = [...value.data, stage.quantity];
        }
      });
    });

    return items;
  };

  return (
    <div className="chart mt-5">
      <Bar
        data={{
          labels: getGraphicResponsibleLabels(),
          datasets: dataSets()
        }}
        options={{
          showLines: true,
          scales: {
            yAxes: [
              {
                gridLines: {
                  color: '#e9ecef',
                  zeroLineColor: '#e9ecef'
                },
                ticks: {
                  callback: function (value) {
                    if (!(value % 10)) {
                      return value;
                    }
                  }
                }
              }
            ],
            xAxes: [
              {
                stacked: true,
                maxBarThickness: 100
              }
            ]
          },
          tooltips: {
            callbacks: {
              label: function (item, data) {
                var label = data.datasets[item.datasetIndex].label || '';
                var yLabel = item.yLabel;
                var content = '';
                if (data.datasets.length > 1) {
                  content += label;
                }
                content += ` ${yLabel}`;
                return content;
              }
            }
          },
          legend: {
            display: false
          }
        }}
        className="chart-canvas"
        id="chart-bars"
      />
    </div>
  );
};

export default GraphicLeadsByResponsibleAndStatus;
